import * as React from 'react';
import { PerformanceRumManager, componentAvailabilityTracker, componentTimingTracker, datadogTracker } from '@shared-ui/core-performance-rum-manager';
import { RumProvider } from '@shared-ui/core-real-user-monitoring/context';

const manager = new PerformanceRumManager([componentAvailabilityTracker(), componentTimingTracker(), datadogTracker()]);
function RumProviderPlugin() {
    return {
        name: 'rum-provider',
        async onBrowserWrapRootElement(pluginContext, next) {
            const { setRootElement } = pluginContext;
            setRootElement((RootElement) => ({ children }) => (React.createElement(RootElement, null,
                React.createElement(RumProvider, { manager: manager }, children))));
            return next(pluginContext);
        },
    };
}

export { RumProviderPlugin as default };
//# sourceMappingURL=browser.js.map
